const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M10.22 5.47a.75.75 0 1 1 1.06 1.06L5.81 12l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06zm8 0a.75.75 0 1 1 1.06 1.06L13.81 12l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06z"/></svg>';
export {
  a as w
};
